import { useQuery } from "@tanstack/react-query";
import { Card, Grid2, Skeleton, Typography } from "components";
import { useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { moneyCommaSeparatorPoint } from "utils/helpers";
import CnsModal from "./CnsModal";

const Overview = () => {
  const { id } = useParams();

  const [openCnsModal, setOpenCnsModal] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: ["GET_ADVISOR_OVERVIEW"],
    queryFn: () => axiosInstance.get(`/super_admin/${id}/advisor_overview/`),
  });

  const overviewDetails = [
    {
      name: "Admins Created",
      value: data?.data?.data.adminsCreated || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Partners Created",
      value: data?.data?.data.partnersCreated || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Clients Created",
      value: data?.data?.data.clientsCreated || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Portfolios Created",
      value:
        data?.data?.data.portfolioCreated || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "AUM",
      value:
        moneyCommaSeparatorPoint(data?.data?.data.aum) ||
        (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Trades Imported",
      value: data?.data?.data.tradesImported || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Baskets Created",
      value: data?.data?.data.basketCreated || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Model Portfolios Created",
      value:
        data?.data?.data.modelPortfoliosCreated ||
        (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Smallcase portfolios registered",
      value:
        data?.data?.data.smallcasePortfoliosRegistered ||
        (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Monthly Smallcase unique use accounts",
      value: data?.data.smallcase || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Auto Imports Setup",
      value: data?.data?.data.autoImportSetup || (isLoading ? <Skeleton /> : 0),
    },
    {
      key: "cnsParsed",
      name: "CNs parsed",
      value: data?.data?.data.cnParsed || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Risk Profiles Done",
      value: data?.data?.data.riskprofileDone || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "KYC done",
      value: data?.data?.data.kycDone || (isLoading ? <Skeleton /> : 0),
    },
    {
      name: "Agreements Signed",
      value: data?.data?.data.agreementSigned || (isLoading ? <Skeleton /> : 0),
    },
  ];

  return (
    <Grid2 container spacing={2.5}>
      {overviewDetails.map((item, index) => (
        <Grid2 size={4} key={index}>
          <Card
            onClick={() => item.key === "cnsParsed" && setOpenCnsModal(true)}
            sx={{
              padding: 2,
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: 2,
              textAlign: "center",
              cursor: item.key === "cnsParsed" ? "pointer" : "default",
              border: "1px solid #ccc",
              backdropFilter: item.key === "cnsParsed" ? "blur(3px)" : "none",
              transition: "0.25s",
              "&:hover": item.key === "cnsParsed" && {
                border: "2px solid var(--primary-900)",
                boxShadow: "0 0 18px rgba(1, 101, 127, 0.3)",
                transform: "scale(1.03)",
              },
            }}
          >
            <Typography
              fontSize={16}
              fontWeight={500}
              color={"var(--grey-700)"}
            >
              {item.name}
            </Typography>
            <Typography
              fontSize={16}
              fontWeight={700}
              color={"var(--primary-900)"}
              marginTop={1}
            >
              {item.value}
            </Typography>
          </Card>
        </Grid2>
      ))}
      {openCnsModal && (
        <CnsModal open={openCnsModal} setOpen={setOpenCnsModal} />
      )}
    </Grid2>
  );
};

export default Overview;
